import React, { Component } from 'react'

import './style.scss'

export default class InactivityIndicatorHeader extends Component {
    render() {
        return <div className={'inactive-indicator-header'} />
    }
}
